import React, { useContext, useEffect, useState } from 'react';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { ApiContext } from '@api/api.tsx';
import { CargoTemplateWithoutIdDTO } from '@api/ringil-api.v2.tsx';
import { isNotNullOrUndefined } from '@utils/utils.tsx';
import { toTestIdSlug } from '@utils/testUtils';

interface ComponentProps {
  value: string;
  companyId: string;
  onChange: (code: string) => void;
  fullWidth?: boolean;
  fullHeight?: boolean;
  onChangeCargoTemplate?: (cargoTemplate: CargoTemplateWithoutIdDTO) => void;
  disabled?: boolean;
  dataTestId?: string;
  dataTestItemIdPrefix?: string;
}

const InputSKU: React.FC<ComponentProps> = ({
                                              value,
                                              companyId,
                                              onChange,
                                              fullWidth,
                                              fullHeight,
                                              onChangeCargoTemplate,
                                              disabled = false,
                                              dataTestId,
                                              dataTestItemIdPrefix,
                                            }) => {
  const { lovCargoItemTypeForCompany } = useContext(ApiContext);
  const [cargoTemplates, setCargoTemplates] = useState<CargoTemplateWithoutIdDTO[]>();

  useEffect(() => {
    lovCargoItemTypeForCompany(companyId, d => setCargoTemplates(d));
  }, [companyId]);

  const style = {
    width: fullWidth ? '100%' : undefined,
    height: fullHeight ? '100%' : undefined,
  };

  return (
    <div data-testid={dataTestId} style={{ display: 'contents' }}>
      <Dropdown
        style={style}
        value={value}
        options={cargoTemplates}
        onChange={e => {
          onChange(e.target.value);
          if (isNotNullOrUndefined(onChangeCargoTemplate)) {
            const cargoTemplate = cargoTemplates?.find(c => c.code === e.target.value);
            if (isNotNullOrUndefined(cargoTemplate)) {
              onChangeCargoTemplate(cargoTemplate);
            }
          }
        }}
        optionLabel="name"
        optionValue={'code'}
        disabled={disabled}
        itemTemplate={dataTestItemIdPrefix ? (option) => (
          <span data-testid={`${dataTestItemIdPrefix}-${toTestIdSlug(option.code)}`}>{option.name}</span>
        ) : undefined}
      />
    </div>
  );
};

export default InputSKU;
